import Select from "react-select";
import React from "react";
import PropTypes from "prop-types";

import "./Select.styles.scss";
import makeAnimated from 'react-select/animated';
const animatedComponents = makeAnimated();

const MyMultiSelect = props => {
  return (
    <div className="select-box">
      <Select
        value={props.value}
        placeholder={props.placeholder}
        options={props.options}
        onChange={props.onChange}
        defaultValue={props.defaultValue}
        isMulti
        closeMenuOnSelect={false}
      ></Select>
    </div>
  );
};

const MySelect = props => {
  return (
    <div className="select-box">
      <Select
        value={props.value}
        placeholder={props.placeholder}
        options={props.options}
        onChange={props.onChange}
        defaultValue={props.defaultValue}
        isDisabled={props.isDisabled}
      ></Select>
    </div>
  );
};

const MyCustomSelect = props => {
  if (props.allowSelectAll) {
    return (
      <div className="select-box">
      <Select
       styles={props.placeholder==='Category'?{menu: styles => ({ ...styles,                 
        minWidth: '200px',
        textAlign:'left'
       })}:props.placeholder==='Brands'?{menu: styles => ({ ...styles,                 
        minWidth: '300px',
        textAlign:'left'
       })}:props.placeholder==='MSKUs'?{menu: styles => ({ ...styles,                 
        minWidth: '400px',
        textAlign:'left'
       })}:props.placeholder==='Demand Driver'?{menu: styles => ({ ...styles,                 
        minWidth: '300px',
        textAlign:'left'
       })}:props.placeholder==='Channel'?{menu: styles => ({ ...styles,                 
        minWidth: '200px',
        textAlign:'left'
       })}:{menu: styles => ({ ...styles,
        textAlign:'left'
       })}}
        {...props}
        options={[props.allOption,   ...props.options]}
        value={props.value}
        defaultValue={props.label}
        placeholder={props.placeholder}
        id={props.labelId}
        isClearable={props.isClearable}
        components={animatedComponents}
        isMulti
        closeMenuOnSelect={false}
        isDisabled={props.isDisabled}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onChange={selected => {
          if (
            selected !== null &&
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange(props.options);
          }
          return props.onChange(selected);
        }}
      />
      </div>
    );
  }

  return <Select {...props} />;
};

MyCustomSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MyCustomSelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*"
  }
};


const PratMultiSelect = props => {
  return (
    <div className="select-box">
      <Select
        value={props.value}
        placeholder={props.placeholder}
        options={props.options}
        onChange={props.onChange}
        defaultValue={props.defaultValue}
        isMulti
        closeMenuOnSelect={false}
        components={animatedComponents}

      ></Select>
    </div>
  );
};

const MyInput = props => {
  return (
    <div className="select-box">
     <input
     className={props.className}
       name={props.name}
       value={props.value}
       onChange={props.onChange}
       placeholder={props.placeholder}
       required
     >
     </input>
    </div>
  );
};

const CustomSelect = { MySelect, MyMultiSelect,PratMultiSelect,MyCustomSelect,MyInput };

export default CustomSelect;
